import React, { Component } from 'react';
export class ErrorItemTable extends Component {
  static displayName = ErrorItemTable.name;

  constructor(props) {
    super(props);
    this.state = { rowEntries: props.errorItems, loading: false };
  }

  componentDidMount() {
  }

  static renderTable(rowEntries) {
    return (
      <>
        <h4>Error Item List</h4>
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>Severity</th>
            <th>Code</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {rowEntries.map((row, index) =>
            <tr key={index}>
              <td>{row.severity}</td>
              <td>{row.code}</td>
              <td>{row.details}</td>
            </tr>
          )}
        </tbody>
        </table>
        </>
    );
  }

  render() {
    let contents = this.state.loading || this.state.rowEntries === undefined
      ? <p><em>Loading...</em></p>
      : ErrorItemTable.renderTable(this.state.rowEntries);

    return (
      <div>
        {contents}
      </div>
    );
  }
}